
export function cnpjMask (value) {

  if (!value) return;

  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // primeiro ponto
    .replace(/(\d{3})(\d)/, '$1.$2') // segundo ponto
    .replace(/(\d{3})(\d)/, '$1/$2') // barra
    .replace(/(\d{4})(\d)/, '$1-$2');

}

export function phoneMask (value){
  if (value){
    var val = value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d)/, '($1') // primeiro parentes
      .replace(/(\d{2})(\d)/, '$1) $2'); // segundo parenteses
    if(value.replace(/\D/g, '').length <= 10){
      return val.replace(/(\d{4})(\d)/, '$1 $2')
    }
    return val
      .replace(/(\d{3})(\d)/, '$1 $2')
      .replace(/(\d{3})(\d)/, '$1 $2')
      .replace(/( \d{3})\d+?$/, '$1') // captura 3 numeros seguidos de um espaco e não deixa ser digitado mais nada
  }
  return null;
}

export function validaNome(nome){
  if (nome) {
    return !!nome.match(/^[A-ZÀ-Ÿ][A-zÀ-ÿ']+\s([A-zÀ-ÿ']\s?)*[A-ZÀ-Ÿ][A-zÀ-ÿ']+$/);
  }
  return false;
}